"use client";

import { useEffect } from "react";
import { captureCurrentAttribution } from "@/lib/attribution";

export function AttributionCapture() {
  useEffect(() => {
    captureCurrentAttribution();
  }, []);

  return null;
}
